<div id="teacher-dashboard">
  <div class="dashboard-container" [class.is-mobile]="isMobile">
    <!-- [sideNav]="calendarNav" -->
    <app-header (height)="onGetHeight($event)"></app-header>
    <mat-sidenav-container class="sidenav-container">
      <!-- Start SideNav -->
      <!-- <mat-sidenav
          #calendarNav
          [mode]="isMobile ? 'over' : 'side'"
          [fixedInViewport]="isMobile"
          [fixedTopGap]="headerHeight"
          [opened]="!isMobile"
        >
          <app-sidenav type="teacher-calendar" [sideNav]="calendarNav">
          </app-sidenav>
        </mat-sidenav> -->
      <!-- End SideNav -->

      <mat-sidenav-content>
        <router-outlet></router-outlet>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>

<app-loading [loading]="loading"></app-loading>
<app-footer></app-footer>
